import { GetTeamMembersPageDocument } from './use-team-members.generated'

export interface TeamMember {
  id: string
  display: string
  email: string
  gravatar: string
}

const PAGE_SIZE = 50

export default function () {
  const members = ref<TeamMember[]>([])
  const adminMembers = ref<TeamMember[]>([])
  const isFetching = ref(false)

  const { execute } = useQuery({
    query: GetTeamMembersPageDocument,
    fetchOnMount: false,
    skip: () => !isFetching.value,
    cachePolicy: 'network-only',
  })

  async function fetchAll(teamId: string): Promise<void> {
    isFetching.value = true
    const collected: TeamMember[] = []
    let adminsSet = false
    let after: string | null = null
    try {
      while (true) {
        const response = await execute({ variables: { id: teamId, first: PAGE_SIZE, after } })
        const team = response.data?.organization?.team
        if (!team) break
        if (!adminsSet) {
          adminMembers.value = (team.adminMembers ?? []) as TeamMember[]
          adminsSet = true
        }
        for (const node of getListOfNodes(team.members)) {
          collected.push({ id: node.id, display: node.display, email: node.email, gravatar: node.gravatar })
        }
        if (!team.members.pageInfo.hasNextPage) break
        after = team.members.pageInfo.endCursor ?? null
      }
      members.value = collected
    } finally {
      isFetching.value = false
    }
  }

  function reset(): void {
    members.value = []
    adminMembers.value = []
  }

  return { members, adminMembers, isFetching, fetchAll, reset }
}
